// Copyright (c) 2016 Deere & Company

import Accordion, {getDefaultState as getAccordionDefaultState} from '../../../shared/components/smart-accordion/state/accordion';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import KeyValuePairCollection, {getDefaultState as getDefaultKeyValueCollection} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from '../../shared/state/search-by-dropdown';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import Transfers, {getDefaultState as getTransfersDefaultState} from './transfers';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    facets: Facets,
    hasSearchResults: t.Boolean,
    rejectedReason: KeyValuePairCollection,
    reportsAccordion: Accordion,
    searchByDropDown: SearchByDropDown,
    searchFilters: SearchFilters,
    searchQueryString: t.String,
    transfers: Transfers
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        facets: getFacetsDefaultState(),
        hasSearchResults: false,
        rejectedReason: getDefaultKeyValueCollection(),
        reportsAccordion: getAccordionDefaultState('transfer-approvals-reports'),
        searchByDropDown: getSearchByDropDownDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        searchQueryString: '',
        transfers: getTransfersDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/product/transfers/state/index.js